import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function Head() {
    return _jsx("head", {});
}
